export enum DisplayLanguage {
    ENGLISH = 0,
    SPANISH = 1,
    CREOLE = 2
}

export class Verbiage {
    Language : DisplayLanguage;
    Verbiage : string;
    Component? : string;
}


// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/Models/DisplayLanguage.ts